<template>
  <zm-popover
    v-if="isVisible"
    :disabled="!$context.is.desktop"
    placement="top"
    trigger="hover"
    class="opc-cart__sharelink"
    :tab-to-leave="false"
    :content="copySuccess ? 'Copied to clipboard' : 'Copy Link'"
  >
    <div slot="reference">
      <zm-button
        data-testid="checkout-button-398"
        type="link"
        v-show="copyInit"
        class="opc-cart__sharelink__copy"
        icon="zm-icon-link"
        :loading="loading"
        aria-label="Copy Link"
        @click="generateCartId"
      />
      <i v-show="copySuccess" aria-label="Copied to clipboard" class="zm-icon-success opc-cart__sharelink__success" />
    </div>
  </zm-popover>
</template>

<script>

/** refactored from plan-count.vue */

import { mapGetters } from 'vuex';
import { generateCartId } from '@/apis/cart';

export const SHARE_TYPE_ENUM = {
  DEF: 'true',
  ADD_QTY: 'addQty',
};

export const SHARE_TYPES = Object.values(SHARE_TYPE_ENUM);

const copyStatusMap = {
  init: 0,
  done: 1,
};

export const generateCartIdWithQueryKey = 'generateCartId';

export default {
  name: 'ShareLink',
  data() {
    return {
      loading: false,
      copyStatus: copyStatusMap.init,
    };
  },
  computed: {
    ...mapGetters(['getSelectedPlans', 'orderDataPayload', 'getSelectedPlansWithQuantityMap', 'couponState', 'selectedPlanListWithVendorProduct']),
    isVisible(){
        return SHARE_TYPES.includes(this.$config(generateCartIdWithQueryKey))
    },
    copyInit() {
      return this.copyStatus === copyStatusMap.init;
    },
    copySuccess() {
      return this.copyStatus === copyStatusMap.done;
    },
    shareLinkDepData() {
      return {
        getSelectedPlansWithQuantityMap: this.getSelectedPlansWithQuantityMap,
        couponCode: this.couponState?.couponCode,
      };
    },
  },
  methods: {
    async generateCartId() {
      try {
        this.loading = true;

        const cartType = this.$config(generateCartIdWithQueryKey) === SHARE_TYPE_ENUM.DEF && this.$context.flow || this.$config(generateCartIdWithQueryKey)

        const result = await generateCartId({
          orderData: {
            ...this.orderDataPayload,
            planList: this.selectedPlanListWithVendorProduct,
          },
          configData: {
            type: cartType,
            plan: this.$config('plan'),
            from: this.$config('from'),
            period: this.$config('period'),
            dpi: this.$config('dpid'),
          },
        });
        const { urlCode } = result;

        const textarea = document.createElement('textarea');
        textarea.textContent = `${location.origin}/buy?cartid=${urlCode}${this.$config(generateCartIdWithQueryKey) === SHARE_TYPE_ENUM.ADD_QTY ? '&forceSignIn=true':''}`;
        textarea.className = 'opc_hidden_element';
        document.body.appendChild(textarea);
        const selection = document.getSelection();
        const range = document.createRange();
        range.selectNode(textarea);
        selection.removeAllRanges();
        selection.addRange(range);
        document.execCommand('copy');
        document.body.removeChild(textarea);
        this.copyStatus = copyStatusMap.done;
      } finally {
        this.loading = false;
      }
    },
  },
  watch: {
    shareLinkDepData: {
      handler() {
        this.copyStatus = copyStatusMap.init;
      },
    },
  },
};
</script>

<style lang="scss">
.opc-cart__sharelink {
  &__copy {
    &.zm-button {
      width: 20px;
      height: 20px;
      background: transparent;
      border: none !important;
      padding: 0px;
      .zm-icon-link {
        font-size: 14px;
        color: #515079;
      }
    }
  }

  &__success {
    color: #008049;
    font-size: 16px;
    margin-left: 10px;
    cursor: pointer;
  }
}
</style>
